import { Dispatch, SetStateAction, useEffect } from 'react';

export default function useE2ERefresh(
  active: boolean | undefined,
  refresh: number,
  setRefresh: Dispatch<SetStateAction<number>>
) {
  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(() => setRefresh((value) => value + 1), 15000);
    return () => window.clearTimeout(timer);
  }, [active, refresh, setRefresh]);
}
